export default "__VITE_ASSET__DAJwOYTj__"